$.widget("bluaul.vcShareUrlIcon",
{
    // <summary>
    // Switches the user to the given logger and shows some intermediate infos while loading
    // Author: AFU<br />
    // Date: 21.9.2021<br />
    // Copyright ©: EUDT GmbH 2021 <br />
    // Version-History:<br />
    // **********************************************************************<br />
    // * - basic functionality                                              *<br />
    // **********************************************************************<br />
    // </summary>

    options: {vcgid:"-1", showOnStart:false},
    ShareUrlSettings: {  },

    _create: function () {
        var me = this;

        //TODO: activate/deactivate

        me.dialogUrl = $("<div>").attr("id", "infoDialog").css({ display: "none", overflow: "none!important" });
        me.dialogUrl.loaded = false;
        me.dialogUrl.dialog({
            autoOpen: false, modal: true, resizable: false,
            dialogClass: "saveDialog",
            title: "",
            height: 650,
            width: 640,
            closeOnEscape: true,
            position: { my: 'top-65%', at: 'center', of: window },
            buttons: {
                "close": function () {
                    window._VCMQ.produce(me.element, "-1", 'EXPORT_URL_CLOSE', "");
                     me.dialogUrl.dialog('close');
                }
            }
        });
        var icon = $("<i>").addClass('vc-list-icon popup fas fa-share-all color-font-secondary');
        icon.attr("title", "Share Url");
        icon.css("cursor", "pointer").css("font-size", "20px");

        this.element.html(icon);
        this.element.on("click", function () {
            me.show();
        });


        window._VCMQ.addConsumer("-1");
        window._VCMQ.consume(me.element, '-1', function (event) {
          
            if (event.vcgid === me.options.vcgid || me.options.vcgid === "-1") {

                switch (event.msg) {

                    case 'GET_EXPORT_URL_SETTINGS':

                        me.ShareUrlSettings = event.values;
                        
                        break;
                }
            } 
        });


        return true;
    },
    //create the input field and add the change event handlers
    show: function () {
        var me = this;

        me.dialogUrl.loaded = false;
      
      
        me.dialogUrl.html("<div id='divShareUrl'></div>");
        $("#divShareUrl").ShareUrl({ invokeType: "addVisualBase", parameter: me.ShareUrlSettings });
        me.dialogUrl.dialog("open");
    },
  
});
